// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3dGpc","modalFooterButton":"ModalNotes_modalFooterButton__3z7Ve"};